import { useQuery } from '@apollo/client';
import { Spinner } from '../core/Spinner';
import { getWrappedAsset, shortenLongWord } from '../../utils/deso';
import { DESO_ZERO_PUBLIC_KEY } from '../../constants/AppConstants';
import { DESO_TOKEN_DISPLAY_NAME } from '../../utils/constants';
import { Account, AccountExtendedByPublicKeyDocument } from '../../graphql/codegen/graphql';
import { getUserName } from '../../utils/user';

interface UsernameByPublicKeyProps {
  publicKey: string;
  className?: string;
  customPrefix?: string;
}

const UsernameByPublicKey = ({ publicKey, className, customPrefix = '' }: UsernameByPublicKeyProps) => {
  const { data, loading, error } = useQuery(AccountExtendedByPublicKeyDocument, {
    variables: { publicKey },
    skip: publicKey === DESO_ZERO_PUBLIC_KEY || !!getWrappedAsset(publicKey, 'publicKey'),
  });

  if (publicKey === DESO_ZERO_PUBLIC_KEY) {
    return (
      <span className={className}>
        {customPrefix}
        {DESO_TOKEN_DISPLAY_NAME}
      </span>
    );
  }

  const wrappedAsset = getWrappedAsset(publicKey, 'publicKey');
  if (wrappedAsset) {
    return (
      <span className={className}>
        {customPrefix}
        {wrappedAsset.displayName}
      </span>
    );
  }

  if (loading) {
    return <Spinner size={20} />;
  }

  if (error) {
    console.error('Error fetching username:', error);
    return <span className={className}>N/A</span>;
  }

  const username = getUserName({ account: data?.accountByPublicKey as Account, customPrefix });

  return <span className={className}>{username}</span>;
};

export default UsernameByPublicKey;
